import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY_MAP } from 'src/constants';
import { getRetryTaskConfigIdPromise } from '../../../utils/api/get-retry-task-config-id';

export const useGetRetryTaskConfigId = (taskId: string) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: [QUERY_KEY_MAP.useGetRetryTaskConfigId, taskId],
    queryFn: () => getRetryTaskConfigIdPromise(taskId),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });

  return {
    data,
    isLoading,
    isError,
  };
};
